import { useMemo } from 'react';

import { WorkflowProcessConfigState } from '~/scenes/AdminModule/components/Views/WorkflowsConfigurationView/data';
import { theme, themeColors } from '~/theme';
import { getBackgroundImage45DegLines } from '~/utils/helper';

export const useSxStyles = () => {
  // TODO move to be used as utility function
  // const rowInColor = (color: string, hover: string, select: string) => {
  //   return {
  //     backgroundColor: color,
  //     '&:hover, &.Mui-hovered': {
  //       backgroundColor: hover,
  //     },
  //     '&.Mui-selected': {
  //       backgroundColor: select,
  //       '&:hover, &.Mui-hovered': {
  //         backgroundColor: select,
  //       },
  //     },
  //   };
  // };

  return useMemo(() => {
    const getRowStateClassName = (state: WorkflowProcessConfigState) =>
      `& .workflow-row--${state}`;

    return {
      gridView: {
        display: 'grid',
        gridTemplateColumns: '1fr',
        gridTemplateRows: 'auto 1fr',
        gridTemplateAreas: `
            "gridHeader"
            "gridContainer"
          `,
      },
      gridHeader: {
        gridArea: 'gridHeader',
        height: '100%',
      },
      gridContainer: {
        gridArea: 'gridContainer',
        padding: theme.spacing(1),
      },
      dataGrid: {
        backgroundColor: '#fff',
        [getRowStateClassName(WorkflowProcessConfigState.Undefined)]: {
          color: theme.palette.text.disabled,
          backgroundImage: getBackgroundImage45DegLines(
            themeColors.background.grey,
            'transparent',
          ),
          backgroundSize: '8px 8px',
        },
        [getRowStateClassName(WorkflowProcessConfigState.Inherited)]: {
          color: theme.palette.text.disabled,
        },
      },
    };
  }, []);
};
